export default __webpack_public_path__ + "static/media/logo.dfc69370.svg";